var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label",class:{'flex':_vm.flex}},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }